import type { ProjectSection } from "@/shared/types/project";

/**
 * Permissões das seções de acesso da obra (espelha ProjectSection no backend).
 * `global` é a permissão de sistema; `project` é a permissão do cargo na obra.
 * GENERAL e DOCUMENTS reaproveitam permissões que já existiam.
 */
export const PROJECT_SECTION_PERMISSIONS: Record<ProjectSection, { global: string; project: string }> = {
    GENERAL: { global: "CAN_GET_PROJECT", project: "CAN_GET_THIS_PROJECT" },
    SCHEDULE: { global: "CAN_GET_PROJECT_SCHEDULE", project: "CAN_GET_THIS_PROJECT_SCHEDULE" },
    TECHNICAL: { global: "CAN_GET_PROJECT_TECHNICAL", project: "CAN_GET_THIS_PROJECT_TECHNICAL" },
    FINANCIAL: { global: "CAN_GET_PROJECT_FINANCIAL", project: "CAN_GET_THIS_PROJECT_FINANCIAL" },
    CLIENT: { global: "CAN_GET_PROJECT_CLIENT", project: "CAN_GET_THIS_PROJECT_CLIENT" },
    DOCUMENTS: { global: "CAN_GET_PROJECT_WALLET_FILE", project: "CAN_GET_THIS_PROJECT_WALLET_FILE" },
    TEAM: { global: "CAN_GET_PROJECT_TEAM", project: "CAN_GET_THIS_PROJECT_TEAM" },
};
